import {Skeleton} from 'antd';
import styled from 'styled-components';
const React = require('react');

const CheckoutSummary = (props) => {
  const {
    cart,
    onClick,
    disabled = false,
    buttonLabel = '下一步',
    prevButtonLabel = '上一步',
    onPrevClick,
    renderExtraCheckoutSummary,
    renderFeeItems,
    renderDiscountItems,
    renderCheckoutButton,
    amountSyncing = false,
    lastStep = false,
  } = props;

  const fees = [
    ...(cart.extra_items || []).map((i) => ({...i, type: 'extra'})),
  ];
  const discounts = [
    ...(cart.discount_items || []).map((i) => ({...i, type: 'discount'})),
  ];

  return (
    <Wrapper>
      <div className="detail-info">
        <h2 className="header">金額資訊</h2>
        {amountSyncing ? (
          <div className="amount-syncing" aria-live="polite">
            <div className="skeleton-group amount">
              <Skeleton
                active
                title={false}
                paragraph={{
                  rows: 4,
                  width: ['90%', '85%', '80%', '95%'],
                }}
              />
            </div>
            <div className="skeleton-group discount">
              <Skeleton.Input active block style={{height: 16, width: '60%'}} />
              <Skeleton.Input active block style={{height: 56}} />
              <Skeleton.Input active block style={{height: 56}} />
            </div>
          </div>
        ) : (
          <div className="price-table">
            <div className="item subtotal">
              <h4 className="label">小計</h4>
              <h4 className="value">${cart.subtotal}</h4>
            </div>

            {typeof renderFeeItems === 'function'
              ? renderFeeItems({fees})
              : fees.map((fee, index) => (
                  <div className="item fee" key={index}>
                    <h4 className="label">{fee.name}</h4>
                    <h4 className="value">${fee.amount}</h4>
                  </div>
                ))}

            {typeof renderDiscountItems === 'function'
              ? renderDiscountItems({discounts})
              : discounts.map((discount, index) => (
                  <div className="item discount" key={index}>
                    <h4 className="label">{discount.name}</h4>
                    <h4 className="value">
                      {discount.amount > 0
                        ? `- $${discount.amount}`
                        : `+ $${-discount.amount}`}
                    </h4>
                  </div>
                ))}

            <div className="item total">
              <h2 className="label">總金額</h2>
              <h2 className="value">${cart.total}</h2>
            </div>
          </div>
        )}
        {!amountSyncing && props.children}
      </div>

      {renderExtraCheckoutSummary && renderExtraCheckoutSummary({cart})}

      {typeof renderCheckoutButton === 'function' ? (
        renderCheckoutButton({cart, disabled, onClick, buttonLabel})
      ) : (
        <button
          id="checkout-btn"
          className="step-btn next-step"
          disabled={disabled}
          onClick={onClick}>
          <div>{buttonLabel}</div>
        </button>
      )}

      <button className="step-btn prev-step" onClick={onPrevClick}>
        <div>{prevButtonLabel}</div>
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;

  & > .detail-info {
    background-color: white;
    padding: 0 10px 10px 10px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 150ms;
    margin-bottom: 20px;

    & > h2.header {
      font-size: 1.33rem;
      padding: 10px 0;
    }

    & > .amount-syncing {
      border-top: 1px solid #aaa;
      border-bottom: 1px solid #aaa;
      padding: 10px 0;

      & > .skeleton-group {
        display: flex;
        flex-direction: column;
        gap: 8px;

        &:not(:last-child) {
          margin-bottom: 12px;
        }
      }

      & .ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph > li,
      & .ant-skeleton .ant-skeleton-content .ant-skeleton-title,
      & .ant-skeleton .ant-skeleton-input {
        animation-duration: 1.2s !important;
      }
    }

    & > .price-table {
      & > *.item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #aaa;
        padding: 8px 0;

        & h2,
        h4 {
          color: #aaa;
        }

        & > .label {
          flex: 1;
        }
      }

      & > *.item:first-child {
        border-top: 1px solid #aaa;
      }

      & > *.item.total {
        & > .value {
          color: red;
        }
      }
    }
  }

  & button.step-btn {
    width: 100%;
    border-radius: 100px;
    padding: 8px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
    transition: all 200ms;
    cursor: pointer;

    &:hover {
      box-shadow: 0 6px 10px rgba(0, 0, 0, 0.5);
    }

    &:active {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.next-step {
      background-color: teal;
      color: white;
    }

    &.prev-step {
      background-color: #ccc;
      color: white;
    }
  }
`;

export default CheckoutSummary;
